module.exports = __webpack_public_path__ + "static/media/transpak_small.f13ec48b.png";